import { jobsheetTatActions } from "./actionTypes";

export const getJobPrefixExcelLoading = (prefix: any) => {
  return {
    type: jobsheetTatActions.DOWNLOAD_JOB_PREFIX_EXCEL_LOADING,
    prefix
  }
}

export const getJobPrefixExcelSuccess = (resp: any) => {
  return {
    type: jobsheetTatActions.DOWNLOAD_JOB_PREFIX_EXCEL_SUCCESS,
    payload: resp
  }
}

export const getJobPrefixExcelError = (error: any) => {
  return {
    type: jobsheetTatActions.DOWNLOAD_JOB_PREFIX_EXCEL_ERROR,
    payload: error
  }
}

export const getJobsheetCourierTypeOptionsLoading = () => {
  return {
    type: jobsheetTatActions.GET_JOBSHEET_COURIER_OPTION_LOADING,
  }
}

export const getJobsheetCourierTypeOptionsSuccess = (resp: any) => {
  return {
    type: jobsheetTatActions.GET_JOBSHEET_COURIER_OPTION_SUCCESS,
    payload: resp
  }
}

export const getJobsheetCourierTypeOptionsError = (error: any) => {
  return {
    type: jobsheetTatActions.GET_JOBSHEET_COURIER_OPTION_ERROR,
    payload: error
  }
}

export const clearJobsheetTatMessage = () => {
  return {
    type: jobsheetTatActions.JOBSHEET_TAT_CLEAR,
  }
}